/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Default_Catch_Boundary_Retry_LabelInputs */

const en_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

const de_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneut versuchen`)
};

const pt_br2_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentar novamente`)
};

const tr_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar dene`)
};

const zh_cn2_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重试`)
};

const zh_hk2_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試一次`)
};

const ko_kr2_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 시도`)
};

const ru_ru2_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторить попытку`)
};

const es_419_components_default_catch_boundary_retry_label = /** @type {(inputs: Components_Default_Catch_Boundary_Retry_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intentar de nuevo`)
};

/**
* | output |
* | --- |
* | "Try again" |
*
* @param {Components_Default_Catch_Boundary_Retry_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_default_catch_boundary_retry_label = /** @type {((inputs?: Components_Default_Catch_Boundary_Retry_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Default_Catch_Boundary_Retry_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_default_catch_boundary_retry_label(inputs)
	if (locale === "de") return de_components_default_catch_boundary_retry_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_default_catch_boundary_retry_label(inputs)
	if (locale === "tr") return tr_components_default_catch_boundary_retry_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_default_catch_boundary_retry_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_default_catch_boundary_retry_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_default_catch_boundary_retry_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_default_catch_boundary_retry_label(inputs)
	return es_419_components_default_catch_boundary_retry_label(inputs)
});